<template>
    <b-modal v-model="modal.active"
             headerBgVariant="dark"
             bodyBgVariant="light"
             :title="modal.title"
             no-close-on-esc
             no-close-on-backdrop
             hide-header-close
             centered>

      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item v-for="(item, index) in arr.reports"
                               :key="index"
                               @click="preOpenPDF(item)"
                               href="#"
                               class="flex-column align-items-start container-list-group-item-custom"
                               v-b-tooltip.hover title="Click para elegir un formato de reporte">

              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
              </div>

            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button type="button" variant="outline-secondary" @click="cancelOpenPDF()">Cancelar</b-button>
      </template>

    </b-modal>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Session from '@/handler/session'    

  export default {    
    props: {
      pdf:{
        type: String,
        default: '',
      },
      reference: {
        type: String,
        default: '',        
      },
      registerID: {
        type: Number,
        default: 0,                
      },
      filters: {
        type: Object,
        default: null,
      },
      manyFormat: {
        type: Boolean,
        default: false,
      }
    },    
    data: () => {
      return {
        popup: null,
        modal: {
          active:false, 
          title: 'Seleccionar Reporte'
        },
        arr: {
          reports: [],
        }
      }      
    },
    watch: {        
      pdf: function (newQuestion, oldQuestion) {   
        if(this.manyFormat) {
          this.searchFormat()
        } else {
          this.openPDF()                           
        }        
      },
      reference: function (newQuestion, oldQuestion) {   
        if(this.manyFormat) {
          this.searchFormat()
        } else {        
          this.openPDF()                           
        }
      },
      registerID: function (newQuestion, oldQuestion) {   
        if(this.manyFormat) {
          this.searchFormat()
        } else {        
          this.openPDF()                           
        }
      },      
      filters: function (newQuestion, oldQuestion) {   
        if(this.manyFormat) {
          this.searchFormat()
        } else {        
          this.openPDF()                           
        }
      },
    },
    mounted() {
      if(this.manyFormat) {
        this.searchFormat()
      } else {              
        this.openPDF()
      }
    },
    destroyed () {      
      if(this.popup) {
        this.modal.active = false
        this.popup.close()
      }      
    },         
    methods: {
      searchFormat() {
        var result = serviceAPI.search({
          reference: this.reference,          
        })        
        result.then((response) => {
          this.arr.reports = response.data
          
          if(this.arr.reports.length == 1) {            
            this.openPDF(this.arr.reports[0].reference)
          } 

          if(this.arr.reports.length > 1) {
            this.modal.active = true
          }
        })
      },
      preOpenPDF(item) {        
        this.modal.active = false
        this.openPDF(item.reference)
      },
      cancelOpenPDF() {        
        this.modal.active = false
      },
      openPDF(referenceAlt = null) {        
        let reference = this.reference
        if(referenceAlt) {
          reference = referenceAlt
        }

        if(this.pdf) {       
          this.popup = window.open(this.pdf,
            "Imprimir",
            "toolbar=no," +
            "scrollbars=no," +
            "location=no," +
            "statusbar=no," +
            "menubar=no," +
            "resizable=0," +
            "width=1000," +
            "height=800," +
            "left=300," +
            "top=100"
          );    
        } else {          
          if(reference && this.registerID) {            
            this.generateReports(reference, this.registerID, null)
          } else {
            if(reference && this.filters) {            
              this.generateReports(reference, 0, this.filters)
            }            
          }
        }
      },
      generateReports(reference, registerID=0, filters=null) {
        let loader = this.$loading.show();

        var result = serviceAPI.generate({
          reference: reference,
          regID: registerID,
          filters: filters,
          staff_id: Helper.getStaffId(),
        })

        result.then((response) => {
          loader.hide()
          var data = response.data                        
          this.popup = window.open(data,
            "Imprimir",
            "toolbar=no," +
            "scrollbars=no," +
            "location=no," +
            "statusbar=no," +
            "menubar=no," +
            "resizable=0," +
            "width=1000," +
            "height=800," +
            "left=300," +
            "top=100"
          );                      
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });             
      }      
    }
  }
</script>